/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import moment from 'moment'

export const getDateTime = (date, time) => {
  const dateMoment = moment(date)
  const timeMoment = moment(time)

  return dateMoment.set({
    hours: timeMoment.hours(),
    minutes: timeMoment.minutes(),
    seconds: 0
  }).format('YYYY-MM-DD HH:mm:ss')
}



// WEBPACK FOOTER //
// ./src/utils/date.js